export default __webpack_public_path__ + "static/media/nnnnn.2dd82302.jpg";